import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {MoodDetails} from "./Moods";

import { useTranslation } from "react-i18next";

function Songs({user}) {
    const API_BASE = "https://moodifyfinal-production.up.railway.app";

    const [songs, setSongs] = useState([]);
    const [selectedSongId, setSelectedSongId] = useState(null);


    const [showAddForm, setShowAddForm] = useState(false);
    const [newSong, setNewSong] = useState({
        Name: "",
        Artist: "",
        Duration_in_Secs: "",
        Release_Date: ""
    });

    const [page, setPage] = useState(1);
    const limit = 15;
    const [total, setTotal] = useState(0);

    const { t } = useTranslation();


    useEffect(() => {
        fetchSongs();
    }, [page]);

    function fetchSongs() {
        fetch(`${API_BASE}/songs?page=${page}&limit=${limit}`)
            .then(res => res.json())
            .then(result => {
                setSongs(result.data);
                setTotal(result.total);
            })
            .catch(err => console.error(err));
    }


    function addSong() {
        fetch(`${API_BASE}/songs/add`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                ...newSong,
                Duration_in_Secs: Number(newSong.Duration_in_Secs)
            })
        })
            .then(res => {
                if (!res.ok) {
                    return res.json().then(err => {
                        throw new Error(err.error);
                    });
                }
                return res.json();
            })
            .then(() => {
                setNewSong({
                    Name: "",
                    Artist: "",
                    Duration_in_Secs: "",
                    Release_Date: ""
                });
                setShowAddForm(false);
                fetchSongs();
            })
            .catch(err => alert(err.message));
    }

    function cancelAdd() {
        setShowAddForm(false);
        setNewSong({
            Name: "",
            Artist: "",
            Duration_in_Secs: "",
            Release_Date: ""
        });
    }

    return (
        <section id="SONGS">

            {/* SONG DETAILS */}
            {selectedSongId && (
                <SongDetails songId={selectedSongId}  onBack={() => setSelectedSongId(null)}
                user={user}/>
            )}

            {/* ADD SONG */}
            {!selectedSongId && showAddForm && (
                <>
                    <h2 id="Title">{t("Add Song")}</h2>

                    <input
                        placeholder={t("Name")}
                        value={newSong.Name}
                        onChange={e =>
                            setNewSong({ ...newSong, Name: e.target.value })
                        }
                    />

                    <input
                        placeholder={t("Artist")}
                        value={newSong.Artist}
                        onChange={e =>
                            setNewSong({ ...newSong, Artist: e.target.value })
                        }
                    />

                    <input
                        type="number"
                        placeholder={t("Duration in seconds")}
                        value={newSong.Duration_in_Secs}
                        onChange={e =>
                            setNewSong({
                                ...newSong,
                                Duration_in_Secs: e.target.value
                            })
                        }
                    />

                    <input
                        type="date"
                        value={newSong.Release_Date}
                        onChange={e =>
                            setNewSong({
                                ...newSong,
                                Release_Date: e.target.value
                            })
                        }
                    />

                    <br />

                    <button onClick={addSong}>{t("Add")}</button>
                    <button onClick={cancelAdd}>{t("Cancel")}</button>
                    <hr />
                </>
            )}

            {/* SONG LIST */}
            {!selectedSongId && !showAddForm && (
                <>
                    <h2 id="Title">{t("Songs")}</h2>

                    <table>
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>{t("Name")}</th>
                            <th>{t("Artist")}</th>
                            <th>{t("Duration")}</th>
                            <th>{t("Release Date")}</th>
                        </tr>
                        </thead>

                        <tbody>
                        {songs.map(song => (
                            <tr key={song.ID}>
                                <td>{song.ID}</td>
                                <td>
                                    <button
                                        onClick={() =>
                                            setSelectedSongId(song.ID)
                                        }
                                    >
                                        {song.Name}
                                    </button>
                                </td>
                                <td>{song.Artist}</td>
                                <td>{song.Duration_in_Secs}</td>
                                <td>{song.Release_Date}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    <div style={{ marginTop: "10px" }}>
                        <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                            {t("Prev")}</button>

                        <span style={{ margin: "0 10px" }}>Page {page} of {Math.ceil(total / limit)}</span>

                        <button disabled={page >= Math.ceil(total / limit)} onClick={() => setPage(page + 1)}>
                            {t("Next")}</button>
                    </div>

                    <br />

                    {user&& (
                    <button onClick={() => setShowAddForm(true)}>Add Song</button>
                    )}

                    <hr />
                </>
            )}

        </section>
    );
}

function SongDetails({ songId, onBack, user }) {
    const API_BASE = "https://moodifyfinal-production.up.railway.app";
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    const [editSong, setEditSong] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const navigate = useNavigate();

    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);
        fetch(`${API_BASE}/songs/${songId}`)
            .then(res => res.json())
            .then(data => {
                setDetails(data);
                setLoading(false);
            });
    }, [songId]);


    if (loading) {return <p>{t("Loading")}...</p>;}

    if (!details || !details.song) {return <p>{t("Song not found")}</p>;}

    function startEdit() {
        setEditSong({ ...details.song });
        setIsEditing(true);
    }

    function cancelEdit() {
        setIsEditing(false);
        setEditSong(null);
    }

    function saveEdit() {
        fetch(`${API_BASE}/songs/${editSong.ID}/edit`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editSong)
        })
            .then(res => {
                if (!res.ok) throw new Error("Update failed");
                return res.json();
            })
            .then(() => {
                setDetails({
                    ...details,
                    song: editSong
                });
                setIsEditing(false);
            })
            .catch(err => alert(err.message));
    }

    function deleteSong() {
        if (!window.confirm("Are you sure you want to delete this song??")) return;

        fetch(`${API_BASE}/songs/${details.song.ID}/delete`, {
            method: "DELETE"
        })
            .then(res => {
                if (!res.ok) throw new Error("Delete failed");
                onBack();
            })
            .catch(err => alert(err.message));
    }


    return (
        <>
            <h2 id="Title">{t("Song Details")}</h2>

            {!isEditing ? (
                <>
                    <p><strong>ID:</strong> {details.song.ID}</p>
                    <p><strong>{t("Name")}:</strong> {details.song.Name}</p>
                    <p><strong>{t("Artist")}:</strong> {details.song.Artist}</p>
                    <p><strong>{t("Duration")}:</strong> {details.song.Duration_in_Secs}</p>
                    <p><strong>{t("Release Date")}:</strong> {details.song.Release_Date}</p>

                    <h3>{t("Moods this song is in")}</h3>

                    {details.moods.length === 0 && <p>{t("No moods yet")}</p>}

                    <ul>
                        {details.moods.map(mood => (
                            <li key={mood.ID}>
                                <button onClick={() => navigate(`/moods/${mood.ID}`)}>
                                    {mood.Name}
                                </button>
                                (created by {mood.Created_By})
                            </li>
                        ))}
                    </ul>

                    <button onClick={onBack}>{t("Back")}</button>

                    {user && (
                        <>
                            <button onClick={deleteSong}>{t("Delete")}</button>
                            <button onClick={startEdit}>{t("Edit")}</button>
                        </>
                    )}

                    <hr />
                </>
            ) : (
                <>
                    <input
                        value={editSong.Name}
                        onChange={e =>
                            setEditSong({ ...editSong, Name: e.target.value })
                        }
                    />
                    <input
                        value={editSong.Artist}
                        onChange={e =>
                            setEditSong({ ...editSong, Artist: e.target.value })
                        }
                    />
                    <input
                        type="number"
                        value={editSong.Duration_in_Secs}
                        onChange={e =>
                            setEditSong({
                                ...editSong,
                                Duration_in_Secs: Number(e.target.value)
                            })
                        }
                    />
                    <input
                        type="date"
                        value={editSong.Release_Date}
                        onChange={e =>
                            setEditSong({
                                ...editSong,
                                Release_Date: e.target.value
                            })
                        }
                    />

                    <button onClick={saveEdit}>{t("Save")}</button>
                    <button onClick={cancelEdit}>{t("Cancel")}</button>

                    <hr />
                </>
            )}
        </>
    );
}


export default Songs;
export {SongDetails};